/**
 * TRF conversation list rows → the core drawer's row shape (chat/voice
 * parity #1731, Task 2.7). TRF's list carries no messageCount; the drawer's
 * "has messages" gates read the page's hasMessages prop, so 0 is inert and
 * the row subtitle falls back to date + channel badge. One record carries
 * both modalities (DECISIONS 2026-09-05): a voice-origin channel marks the
 * row's sessionType, and the drawer's separate voice list is empty here.
 */
import type { ConversationSummaryLike } from '@core/config/types';
import type { ConversationSummary } from '@/types/chat';

const VOICE_CHANNELS = new Set(['web-voice', 'voice', 'telephone']);

export function toCoreConversationSummary(c: ConversationSummary): ConversationSummaryLike {
  return {
    conversationId: c.id,
    interface: 'trf',
    createdAt: Date.parse(c.created_at) || 0,
    // #1731 phase 6: the server now sends both. The channel derivation stays as
    // the fallback for a row written before that phase — those have no
    // sessionType and no lastActivity of their own.
    lastActivity:
      Date.parse(c.lastActivity ?? '') || Date.parse(c.updated_at) || Date.parse(c.created_at) || 0,
    messageCount: 0,
    sessionType: c.sessionType ?? (VOICE_CHANNELS.has(c.channel) ? 'voice' : 'text'),
    title: c.title ?? null,
    channel: c.channel,
    status: c.status,
  };
}
